import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataService {
    ogId: string = ""
    realmid: string = ""
    menuId: string = ""
    branchId: string = ""
    logo: string = ""
    code: string = ""
    license: string = ""
    filter: string = ""
}
